<h2 mat-dialog-title>Eurotaxsuche</h2>
<div mat-dialog-content>
  <form [formGroup]="formGroup" autocomplete="off">
    <div [ngClass]="{'eurotax-inputs' : (eurotaxresults | async)?.length > 0}">
      <div class="row">
        <div class="col col-xs-12 col-sm-12">
          <div class="input_radio">
            <app-label [control]="eingabeart" for="eingabeart">Eurotax Daten auswählen</app-label>
            <mat-radio-group id="eingabeart" formControlName="eingabeart">
              <mat-radio-button [value]="1">Nationaler Code</mat-radio-button>
              <mat-radio-button [value]="2">Marke & Modell</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>
      <div *ngIf="showMarkeModell">
        <div class="row">
          <div class="col col-xs-12 col-sm-3">
            <ng-template *ngTemplateOutlet="baujahrTemplate"></ng-template>
          </div>
          <div class="col col-xs-12 col-sm-9">
            <div class="custom_select">
              <app-label [control]="marke" class="custom-select__label" for="marke">Marke</app-label>
              <mat-form-field>
                <input type="text" matInput [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="marke" [matAutocomplete]="markeAutoGroup">
                <mat-autocomplete #markeAutoGroup="matAutocomplete" [displayWith]="lookupService.displayValue">
                  <mat-optgroup *ngFor="let group of markeGroupOptions | async" [label]="group.letter">
                    <mat-option *ngFor="let value of group.values" [value]="value">
                      {{ value.Value }}
                    </mat-option>
                  </mat-optgroup>
                </mat-autocomplete>
                <mat-error *ngIf="marke.hasError('lookupValue')">{{ 'SELECTREQUIRED' | translate }}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col col-xs-12 col-sm-6">
            <div class="custom_select">
              <app-label [control]="model" class="custom-select__label" for="model">Modell</app-label>
              <mat-form-field>
                <input type="text" matInput [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="model" [matAutocomplete]="modelAutoGroup">
                <mat-autocomplete #modelAutoGroup="matAutocomplete" [displayWith]="lookupService.displayValue">
                  <mat-optgroup *ngFor="let group of modelGroupOptions | async" [label]="group.letter">
                    <mat-option *ngFor="let value of group.values" [value]="value">
                      {{ value.Value }}
                    </mat-option>
                  </mat-optgroup>
                </mat-autocomplete>
                <mat-error *ngIf="model.hasError('lookupValue')">{{ 'SELECTREQUIRED' | translate }}</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col col-xs-12 col-sm-6">
            <div class="custom_select">
              <app-label [control]="antriebsart" class="custom-select__label" for="antriebsart">Antriebsart</app-label>
              <mat-form-field>
                <mat-select id="antriebsart" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="antriebsart" [compareWith]="lookupService.compareValues">
                  <mat-option *ngFor="let aa of antriebsarten | async" [value]="aa">{{ aa.Value }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div *ngIf="showHubraum">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              <div class="custom_select">
                <app-label [control]="hubraum" class="custom-select__label" for="hubraum">Hubraum</app-label>
                <mat-form-field>
                  <mat-select id="hubraum" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="hubraum" [compareWith]="lookupService.compareValues">
                    <mat-option *ngFor="let h of hubraeume | async" [value]="h">{{ h.Value }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-6">
              <ng-template *ngTemplateOutlet="leistungTemplate"></ng-template>
            </div>
          </div>
        </div>
        <div *ngIf="showTuerenBauart">
          <div class="row">
            <div class="col col-xs-12 col-sm-4">
              <ng-template *ngTemplateOutlet="leistungTemplate"></ng-template>
            </div>
            <div class="col col-xs-12 col-sm-2">
              <div class="custom_select">
                <app-label [control]="tueren" class="custom-select__label" for="tueren">Türen</app-label>
                <mat-form-field>
                  <mat-select id="tueren" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="tueren" [compareWith]="lookupService.compareValues">
                    <mat-option *ngFor="let d of doors | async" [value]="d">{{ d.Value }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-6">
              <div class="custom_select">
                <app-label [control]="bauart" class="custom-select__label" for="bauart">Bauart</app-label>
                <mat-form-field>
                  <mat-select id="bauart" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="bauart" [compareWith]="lookupService.compareValues">
                    <mat-option *ngFor="let b of bauarten | async" [value]="b">{{ b.Value }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showNatcode">
        <div class="row">
          <div class="col col-xs-12 col-sm-3">
            <ng-template *ngTemplateOutlet="baujahrTemplate"></ng-template>
          </div>
          <div class="col col-xs-12 col-sm-9">
            <div class="input">
              <div class="text_info">
                <app-label [control]="natCode" class="input__label" for="eurotaxlist_natCode">Nationaler Code:</app-label>
                <div class="info">
                  <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('NATIONALERCODEINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
                </div>
              </div>
              <mat-form-field>
                <input matInput id="eurotaxlist_natCode" formControlName="natCode">
                <mat-error *ngIf="natCode.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    
      <p *ngIf="(eurotaxresults | async)?.length === 0">Es wurde über Eurotax kein Treffer gefunden!</p>

    </div>

    <mat-radio-group id="eurotaxtlist_select" class="eurotax-list" formControlName="select">
      <div [class.no-data-found]="((eurotaxresults | async) || []).length === 0">

        <table mat-table [dataSource]="dataSource" matSort matSortActive="HandelsBezeichnung" matSortDirection="asc" matSortDisableClear>

          <ng-container matColumnDef="Select" sticky>
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <mat-radio-button [value]="row"></mat-radio-button>
            </td>
          </ng-container>

          <ng-container matColumnDef="HandelsBezeichnung" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Handelsbezeichnung</th>
            <td mat-cell *matCellDef="let row"> {{ row.typBezeichnung }} </td>
          </ng-container>

          <ng-container matColumnDef="Baujahr">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Baujahr</th>
            <td mat-cell *matCellDef="let row"> {{ row.modellImportEnde ? row.modellImportBeginn.substring(0, 4).concat('-').concat(row.modellImportEnde.substring(0, 4)) : row.modellImportBeginn.substring(0, 4).concat('-') }} </td>
          </ng-container>

          <ng-container matColumnDef="Antriebsart">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Antriebsart</th>
            <td mat-cell *matCellDef="let row"> {{ row.typtxtFuelTYPeCd2TXTTextLong }} </td>
          </ng-container>

          <ng-container matColumnDef="Hubraum">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Hubraum</th>
            <td mat-cell *matCellDef="let row"> {{ row.typCapTech }} </td>
          </ng-container>

          <ng-container matColumnDef="Leistung">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Leistung</th>
            <td mat-cell *matCellDef="let row"> {{ row.leistungKw.toString().concat('kW/').concat(row.leistungPs | number).concat('PS') }} </td>
          </ng-container>

          <ng-container matColumnDef="Listenpreis" justify="end">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Listenpreis</th>
            <td mat-cell *matCellDef="let row"> {{ row.preisInkl | customCurrency }} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsToDisplay;">
          </tr>

        </table>

        <mat-paginator [pageSize]="8" hidePageSize showFirstLastButtons></mat-paginator>
      </div>
    </mat-radio-group>
    <ng-template #baujahrTemplate>
      <div class="input">
        <app-label [control]="baujahr" class="input__label" for="eurotaxlist_baujahr">Baujahr:</app-label>
        <mat-form-field>
          <input matInput id="eurotaxlist_baujahr" formControlName="baujahr">
          <mat-error *ngIf="baujahr.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
          <mat-error *ngIf="baujahr.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
          <mat-error *ngIf="!baujahr.hasError('pattern') && baujahr.hasError('min')">{{ 'MINVALUE' | translate:{'value': baujahr.errors.min.min} }}</mat-error>
          <mat-error *ngIf="!baujahr.hasError('pattern') && baujahr.hasError('max')">{{ 'MAXVALUE' | translate:{'value': baujahr.errors.max.max} }}</mat-error>
        </mat-form-field>
      </div>
    </ng-template>
    <ng-template #leistungTemplate>
      <div class="custom_select">
        <app-label [control]="leistung" class="custom-select__label" for="leistung">Leistung</app-label>
        <mat-form-field>
          <mat-select id="leistung" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="leistung" [compareWith]="lookupService.compareValues">
            <mat-option *ngFor="let l of leistungen | async" [value]="l">{{ l.Value }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-template>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button class="button--primary" (click)="close()">Abbrechen und zur manuellen Eingabe wechseln</button>
</div>

